/**
 * The three providers, in the order they are drawn left to right. Ids are the wire ids from
 * docs/api.md; the names, signs and motifs are parody and must stay parody — no real logos,
 * wordmarks or trademarked shapes anywhere in this repo (CLAUDE.md, standing rules).
 *
 * F03 reads `accent` for the skyline tint and F12 keys its store slices by `id`.
 */
export interface Provider {
  readonly id: 'openai' | 'anthropic' | 'google'
  /** The real company, named plainly — the disclaimer depends on the joke being legible. */
  readonly label: string
  /** The sign painted over the courtyard gate in the scene. */
  readonly sign: string
  readonly accent: string
  /**
   * The provider's real status page.
   *
   * The one link on this site that is not a joke. A visitor who has worked out that their editor
   * is broken because Anthropic is broken wants the actual incident, and the drawer is where the
   * page stops being a cartoon and becomes useful — so this is the fallback when an incident
   * arrives without its own `url`, and the only thing a peaceful square's drawer can offer.
   *
   * A hostname is not a logo or a wordmark: linking to a company's own status page is the
   * opposite of passing this site off as theirs (CLAUDE.md, standing rules).
   */
  readonly statusUrl: string
}

export const PROVIDERS: readonly Provider[] = [
  {
    id: 'openai',
    label: 'OpenAI',
    sign: 'OpenPlaza — Definitely Not Closed',
    accent: 'var(--color-openai)',
    statusUrl: 'https://status.openai.com/',
  },
  {
    id: 'anthropic',
    label: 'Anthropic',
    sign: 'Anthropical HQ — Constitutionally Calm',
    accent: 'var(--color-anthropic)',
    statusUrl: 'https://status.anthropic.com/',
  },
  {
    id: 'google',
    label: 'Google',
    sign: 'Googol Campus — Now with 4 colours',
    accent: 'var(--color-google)',
    statusUrl: 'https://status.cloud.google.com/',
  },
]
